module.exports = __webpack_public_path__ + "img/胜利.5bac82d9.gif";